import { labelReports } from "_constants";
import { HeaderMainContent, HeaderTableContent } from "components/shared";
import {
  InputSearchReports,
  InputStateFilter,
  ReportsTable,
} from "./components";

export const ReportsPage = () => {
  return (
    <>
      <HeaderMainContent child={<></>} label={labelReports} />
      <HeaderTableContent
        child={
          <>
            <InputSearchReports />
            <InputStateFilter />
          </>
        }
      />
      <ReportsTable />
    </>
  );
};
